import { ZfLoadingSpinner } from '@zafire/react';

export const FieldLoadingSpinner = () => (
  <div slot="trailing" aria-live="polite">
    <ZfLoadingSpinner size="extra-small" color="primary" type="infinite" aria-label="Loading"></ZfLoadingSpinner>
  </div>
);
